/** One icon boundary. Source-matched line adaptations coexist with named Twenty geometry fallbacks. */
import React,{forwardRef} from 'react';
import {IconArrowsSort as TwentyArrowsSort,IconBuildingSkyscraper as TwentyBuildingSkyscraper,IconColumns as TwentyColumns,IconCurrencyLira as TwentyCurrencyLira,IconLayoutKanban as TwentyLayoutKanban,IconListCheck as TwentyListCheck,IconRefresh as TwentyRefresh,IconTag as TwentyTag,IconTargetArrow as TwentyTargetArrow} from 'twenty-ui/icon';
export * from 'twenty-ui/icon';
export {
 IconChevronDown,IconChevronUp,IconChevronLeft,IconChevronRight,
 IconPlus,IconFilter,IconDots,IconCheck,IconFileText,IconSend,
 IconMessageCircle,IconBell,IconShare,
 IconArrowLeft,IconArrowRight,IconArrowUpRight,IconCalendar,IconCircleCheck,
 IconAlertCircle,IconFlag,IconGripVertical,IconLayoutSidebarLeftExpand,IconList,
 IconLogout,IconMinus,IconSearch,IconUser,IconX,
} from './contra-icons.jsx';
/** Keep unsupported glyph semantics/geometry; normalize only the shared line and accessibility contract. */
const fallback=(name,Component)=>{
 const Icon=forwardRef(function SharedTwentyIcon({size=24,color='currentColor',stroke=1.7,strokeWidth=stroke,title,children,...props},ref){
  const labelled=Boolean(title||props['aria-label']||props['aria-labelledby']);
  return React.createElement(Component,{ref,size,color,stroke:strokeWidth,'data-icon-origin':'twenty-fallback','data-ui-icon':name,'aria-hidden':labelled?undefined:true,role:labelled?'img':undefined,focusable:'false',...props},title&&React.createElement('title',null,title),children);
 });
 Icon.displayName=name;return Icon;
};
export const IconArrowsSort=fallback('IconArrowsSort',TwentyArrowsSort);
export const IconBuildingSkyscraper=fallback('IconBuildingSkyscraper',TwentyBuildingSkyscraper);
export const IconColumns=fallback('IconColumns',TwentyColumns);
export const IconCurrencyLira=fallback('IconCurrencyLira',TwentyCurrencyLira);
export const IconLayoutKanban=fallback('IconLayoutKanban',TwentyLayoutKanban);
export const IconListCheck=fallback('IconListCheck',TwentyListCheck);
export const IconRefresh=fallback('IconRefresh',TwentyRefresh);
export const IconTag=fallback('IconTag',TwentyTag);
export const IconTargetArrow=fallback('IconTargetArrow',TwentyTargetArrow);
